import { types } from "../actions";

/**
 * Validade if index is number and within $list
 * @param {number} index
 * @param {Array} list
 * @returns {Boolean}
 */
const validateIndex = (index, list) => {
    return typeof index === "number" && index >= 0 && index < list.length;
};

/**
 * Reducer to handles states described by a list of boolean
 *
 * Ex: [true, false, true]
 *
 * @param {Array} list of booleans
 * @param {Object} Must implement the following props:
 *  - type: required - must be on of action*
 *  - index?: define the accordion index that takes the action
 *  - single: define whether or not keeping a single true on the list.
 *
 * @returns {Array}
 */
export default function listReducer(state, action) {
    //Unexpected state coming
    if (!Array.isArray(state)) return state;

    //Unexpected actions
    if (!action || !action.type) return state;

    switch (action.type) {
        // Set index on state to true and return new state
        // in case of action.single grant that
        // only index is true and the rest is false
        case types.listIndexTrue:
            if (!validateIndex(action.index, state)) return state;
            return state.map((status, index) => {
                return action.index === index ? true : action.single ? false : status;
            });

        // Set index to false and return new state;
        case types.listIndexFalse:
            //Check if index is valid and inside the state ragente
            if (!validateIndex(action.index, state)) return state;
            //Update value and return a copy
            state[action.index] = false;
            return [...state];

        // Set all values to true and return new state
        // the .fill don't create a copy but changes the
        // the current state (thats why we spread it)
        case types.listAllTrue:
            return [...state.fill(true)];

        // Set all values to false and return new state
        case types.listAllFalse:
            return [...state.fill(false)];

        default:
            return state;
    }
}
